import type { Err } from './common';
import type { Bundle, BundleKey } from './types';

/** Ids present in a list (no duplicate reporting: each section's own `ids` pass does that). */
export const idSet = (list: ({ id?: string | null } | null | undefined)[] | null | undefined) =>
  new Set((list ?? []).map((x) => x?.id ?? '').filter((x) => x !== ''));

/** World flag key patterns (`bld.{id}.tip`) as regexes; `{…}` matches one dotted segment. */
export function flagPatterns(b: Bundle): RegExp[] {
  return (b.worldFlags ?? [])
    .map((f) => f?.key ?? '')
    .filter((k) => k !== '')
    .map(
      (k) =>
        new RegExp(
          `^${k
            .split(/\{[^}]*\}/)
            .map((s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
            .join('[^.]+')}$`,
        ),
    );
}

/** A section list as the server parses it: absent = empty, explicit null = missing, null entries reported. */
export function sectionEntries<T>(
  key: BundleKey,
  list: (T | null)[] | null | undefined,
  err: Err,
): [T, number][] {
  const out: [T, number][] = [];
  if (list === null) {
    err(key, undefined, '', `Bundle is missing '${key}'.`);
    return out;
  }
  (list ?? []).forEach((x, i) => {
    if (x == null) err(key, i, '', `Bundle has an empty entry in '${key}'.`);
    else out.push([x, i]);
  });
  return out;
}
